import { useState, useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'

import Loader from '../../Loader/Loader';
import PaymentSetup from './PaymentSetup';
import PaymentMethodsItem from './PaymentMethodsItem';

import { useStore } from '../../../hook-store/store';
import { 
  cardExpire,
  getCustomerCardPaymentMethods,
  // updateSubscriptionDefaultPaymentMethod,
  // detachPaymentMethod,
 } from '../../../utils/stripe/payment-method-utils';

 import { BACKEND_URL } from '../../../App'

 import './PaymentMethods.css';
// import classes from './PaymentMethods.module.css';


function PaymentMethods(props) {
  const {
    subscriptionId,
    isSubscribe,
  } = props;
  
  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  // const { freeSizeGB } = store.bucketObjectStore;
  const { 
    customerMethods,
  } = store.stripeData;
  const { gLoading } = store.uiStore;

  const [isLoading, setIsLoading] = useState(false);
  const [modifiedMethods, setModifiedMethods] = useState([]);
  const [showPaymentSetup, setShowPaymentSetup] = useState(false);
  // const [selectedId, setSelectedId] = useState('');
  // const [showConfirmDetach, setShowConfirmDetach] = useState(false);
  
  useEffect(() => {
    getPaymentMethodsHandler();
  },[]);

  useEffect(() => {
    if (customerMethods.length > 0) {
      createModifiedMethodsHandler(customerMethods);
    }
  },[customerMethods]);


  const getPaymentMethodsHandler = async () => {
    try {
      setIsLoading(true);
      // setError('');

      const resData = await getCustomerCardPaymentMethods(
        BACKEND_URL, 
        localStorage.getItem('token'),
        localStorage.getItem('customerId'),
      );

      // console.log();

      if (resData.data) {
        const kuraList = resData.data.filter(method => {
          return method.metadata && method.metadata.kuraStorageServices;
        });

        // console.log(kuraList);

        dispatch('SET_CUSTOMERMETHODS', kuraList);

        // setDefaultMethod(methodList);

      }
      setIsLoading(false);

    } catch(err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   if (customerMethods.length > 0 && usageBasedSubscription) {
  //     const methodList = [];

  //     for (const method of customerMethods) {
  //       const cardExpired = cardExpire(method.card.exp_month, method.card.exp_year);
        
  //       if (!cardExpired) {
  //         methodList.push(method);
  //       }
  //     }
  
  //     console.log(methodList);
  //     // if (methodList.length === 1) {
  //     //   dispatch('SET_VALID_DEFAULTMETHOD', methodList[0]);
  //     // }
  
  //     if (methodList.length > 0) {
  //       const subscriptionMethod = methodList.find(method => {
  //         return method.id === usageBasedSubscription.default_payment_method;
  //       });

  //       if (subscriptionMethod) {
  //         dispatch('SET_USAGEBASEDVALIDMETHOD', subscriptionMethod);
  //       } else {
  //         dispatch('SET_USAGEBASEDVALIDMETHOD', null);
  //       }
  //     }
  //     else {
  //       dispatch('SET_USAGEBASEDVALIDMETHOD', null);
  //     }
  //   }
  // },[customerMethods]);


  const createModifiedMethodsHandler = (customerMethods) => {
    
    let noSubscriptionMethods = customerMethods;

    // const subscriptionMethod = customerMethods.find(method => {
    //   return method.id === usageBasedSubscription.default_payment_method;
    // });

    // if (subscriptionMethod) {
    //   noSubscriptionMethods = customerMethods.filter(method => {
    //     return method.id !== subscriptionMethod.id;
    //   });
    // }

    const notExpiredMethods = noSubscriptionMethods.filter(method => {
      return !cardExpire(method.card.exp_month, method.card.exp_year);
    });

    const expiredMethods = noSubscriptionMethods.filter(method => {
      return cardExpire(method.card.exp_month, method.card.exp_year);
    });

    let combined = [];

    // if (subscriptionMethod) {
    //   combined = [subscriptionMethod].concat(notExpiredMethods.concat(expiredMethods));
    // } else {
    //   combined = notExpiredMethods.concat(expiredMethods);
    // }

    combined = notExpiredMethods.concat(expiredMethods);


    const kuraList = combined.filter(method => {
      return method.metadata && method.metadata.kuraStorageServices;
    });
    
    // console.log('notExpiredMethods', notExpiredMethods)
    setModifiedMethods(kuraList);
  };



  let paymentMethodsBody = (
    <div>
      {t('paymentMethod02', 'No payment method, please add new one')}
    </div>
  );


  if (modifiedMethods.length >= 0) {
    paymentMethodsBody = (
      <div className='paymentMethods'>
        {/* <div className="paymentMethodsRow">
          <Link
            to={{
              pathname: '/subscription/account', 
            }}
          >
            go-back-to-sub-account
          </Link>
        </div> */}
        <div 
          className="paymentMethodsRow"
        >
          <span 
          className="paymentMethodsTitle"
          >
            {t('paymentMethod03', 'Payment methods')}
          </span>
        </div>
        <div>
          {isLoading && (
            <Loader />
          )}
        </div>
        <ul 
        className="paymentMethodsRow"
        >
          {modifiedMethods.map(method => {
            // const cardInfo = method.card;
            // const cardExpired = cardExpire(method.card.exp_month, method.card.exp_year);
            
            // // const isSubscriptionMethod = method.id === usageBasedSubscription.default_payment_method;

            return (
              <li key={method.id}>
                <PaymentMethodsItem
                  method={method}
                  subscriptionId={subscriptionId}
                  isSubscribe={isSubscribe}
                />
              </li>
            );
          })}
        </ul>


          <div 
            className="paymentMethodsRow"
          >
            <button className='btnBase'
              disabled={isLoading}
              onClick={() => {
                setShowPaymentSetup(true);
              }}
            >
              {t('paymentMethod04', 'Add new card')}
            </button>
          </div>
          {showPaymentSetup && (
            <div 
            className="paymentMethodsRow"
            >
              <PaymentSetup 
                setShowPaymentSetup={setShowPaymentSetup}
              />
            </div>
          )}
          
      </div>
    );
  }
 

  return (
    <Fragment>
      <div>
        {paymentMethodsBody}
      </div>
    </Fragment>
  );
}

export default PaymentMethods;
